/**
 * Message Encryption Service for Frontend (Web)
 * ENCRYPTION DISABLED - All messages are now plain text
 * This service is kept for backwards compatibility but does no encryption/decryption
 */

class EncryptionService {
  constructor() {
    this.isInitialized = true;
  }

  /**
   * Initialize - no-op since encryption is disabled
   */
  async initialize() {
    this.isInitialized = true;
    return true;
  }

  /**
   * Ensure encryption is initialized - always returns true
   */
  async ensureInitialized() {
    return true;
  }

  /**
   * Encrypt message content - DISABLED, returns content as-is
   */
  async encryptMessageContent(content) {
    return content;
  }

  /**
   * Decrypt message content - DISABLED, returns content as-is
   */
  async decryptMessageContent(content) {
    return content;
  }

  /**
   * Check if content looks encrypted - always returns false
   */
  looksEncrypted(content) {
    return false;
  }

  /**
   * Process a single message object - returns as-is
   */
  processMessage(message) {
    return message;
  }

  /**
   * Process an array of messages - returns as-is
   */
  processMessages(messages) {
    return messages;
  }

  /**
   * Check if content is already encrypted - always returns false
   */
  isContentEncrypted(content) {
    return false;
  }
}

const encryptionService = new EncryptionService();
export default encryptionService;
